import { render, staticRenderFns } from "./NewClone.vue?vue&type=template&id=d7ab9fd0&scoped=true"
import script from "./NewClone.vue?vue&type=script&lang=js"
export * from "./NewClone.vue?vue&type=script&lang=js"
import style0 from "./NewClone.vue?vue&type=style&index=0&id=d7ab9fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ab9fd0",
  null
  
)

export default component.exports